import { createContext } from "react";

const DropdownActionContext = createContext({
    status: false,
    item: null,
    x: 0,
    y: 0,
});

export default DropdownActionContext;
